<template>
    <div class="info-box">
        <div class="look-info">
            <h2>{{OrderTitle}}</h2>
            <p class="address-text">{{OrderAddress}}</p>
            <ul class="info-state clear">
                <li v-for="(item,i) in OrderBaseInfo" :key="i" >
                    <template v-if="item.IsShowPhone">
                        <p>
                            <span>{{ item.Name }}：</span>
                            <strong class="phone-strong">
                                <i @click="bindPhone(item)">{{ item.Value }}</i>
                                <svg t="1598582184846" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="3302" width="16" height="16">
                                    <path d="M774.656 419.84c0 19.968 13.312 33.792 33.792 33.792 20.48 0 33.792-13.312 33.792-33.792-0.512-111.616-90.624-202.24-202.752-202.752-20.48 0-33.792 13.312-33.792 33.792s13.312 33.792 33.792 33.792c74.752 0.512 135.168 60.928 135.168 135.168z" p-id="3303" fill="#f75959"></path><path d="M909.824 419.84c0 19.968 13.312 33.792 33.792 33.792 20.48 0 33.792-13.312 33.792-33.792 0-185.856-152.064-337.408-337.408-337.408-20.48 0-33.792 13.312-33.792 33.792S619.52 150.016 640 150.016c148.48 0 269.824 121.344 269.824 269.824z m-590.848-33.792c7.68 47.616 49.152 227.84 241.664 316.416 8.704 4.096 18.432 3.072 26.112-2.56 27.136-19.456 90.112-64.512 102.912-73.728 19.456-14.336 54.784-27.648 83.968 0.512l153.6 143.872s22.528 36.864 6.656 56.832C889.344 881.152 788.48 993.28 788.48 993.28s-18.944 23.04-56.832 9.728c-61.44-22.016-269.824-128-437.248-326.656C130.56 481.792 87.04 314.368 55.296 197.12c-10.752-38.4-4.608-73.216 24.576-86.528 37.888-17.408 201.216-93.696 201.216-93.696s37.888-10.24 54.272 18.944c16.384 29.184 108.032 155.136 119.296 175.104 13.312 23.04 5.12 42.496-6.656 52.736-14.336 12.288-95.232 80.384-122.368 102.912-5.12 4.608-8.192 12.288-6.656 19.456z" p-id="3304" fill="#f75959"></path>
                                </svg>
                            </strong>
                        </p>
                    </template>
                    <template v-else>
                        <p><span>{{ item.Name }}：</span><i>{{ item.Value }}</i></p>
                    </template>
                </li>
            </ul>
            <span class="click-wrap" @click="toggleBox">
                <i class="int-i">{{boxShow?'收起':'展开'}}</i>
            </span>
        </div>
        <div>
            <transition name="router-slid">
                <div class="list-info-c1" v-show="boxShow">
                    <div class="detail-table-info">
                        <table class="detail-table-list">
                            <thead>
                                <tr>
                                    <th><span>领域</span></th>
                                    <th><span>产品/设备</span></th>
                                    <th><span>服务类型</span></th>
                                    <th><span>产品品牌</span></th>
                                    <th><span>产品系列</span></th>
                                    <template v-if="isToggle">
                                        <th><span>产品数量</span></th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="OrderDetailList.length != 0">
                                    <tr v-for="item in OrderDetailList" :key="item.id">
                                        <td><span>{{item.ProCateAreaName}}</span></td>
                                        <td><span>{{item.ProductCategoryName}}</span></td>
                                        <td><span>{{item.ServiceStageName}}</span></td>
                                        <td><span>{{item.BrandName}}</span></td>
                                        <td><span>{{item.SeriesName}}</span></td>
                                        <template v-if="isToggle">
                                            <td><span>{{item.DeviceCount}}</span></td>
                                        </template>
                                    </tr>
                                </template>
                                <template v-else>
                                     <tr>
                                        <td colspan="6"><span>暂无数据</span></td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <div class="info-wrap-box">
                        <template v-for="(item,index) in OrderDetailInfo.slice(1)">
                            <template v-if="item.Name == '备用联系人' || item.Name == '工程师数量' || item.Name == '工程师资质要求' || item.Name == '工具及备件' || item.Name == '备注'">
                                <template v-if="item.IsShowPhone">
                                    <div style="width: 49%;display: inline-block;vertical-align: top;" :key="index">
                                        <div class="tte-name"><h4><span>{{item.Name}}：</span></h4></div>
                                        <div class="con-body-text" style="overflow: visible;">
                                            <div class="inf-con phone-strong">
                                                <span @click="bindPhone(item)">{{item.Value}}</span>
                                                <svg t="1598582184846" class="icon" viewBox="0 0 1024 1024" version="1.1" p-id="3302" width="16" height="16">
                                                    <path d="M774.656 419.84c0 19.968 13.312 33.792 33.792 33.792 20.48 0 33.792-13.312 33.792-33.792-0.512-111.616-90.624-202.24-202.752-202.752-20.48 0-33.792 13.312-33.792 33.792s13.312 33.792 33.792 33.792c74.752 0.512 135.168 60.928 135.168 135.168z" p-id="3303" fill="#f75959"></path><path d="M909.824 419.84c0 19.968 13.312 33.792 33.792 33.792 20.48 0 33.792-13.312 33.792-33.792 0-185.856-152.064-337.408-337.408-337.408-20.48 0-33.792 13.312-33.792 33.792S619.52 150.016 640 150.016c148.48 0 269.824 121.344 269.824 269.824z m-590.848-33.792c7.68 47.616 49.152 227.84 241.664 316.416 8.704 4.096 18.432 3.072 26.112-2.56 27.136-19.456 90.112-64.512 102.912-73.728 19.456-14.336 54.784-27.648 83.968 0.512l153.6 143.872s22.528 36.864 6.656 56.832C889.344 881.152 788.48 993.28 788.48 993.28s-18.944 23.04-56.832 9.728c-61.44-22.016-269.824-128-437.248-326.656C130.56 481.792 87.04 314.368 55.296 197.12c-10.752-38.4-4.608-73.216 24.576-86.528 37.888-17.408 201.216-93.696 201.216-93.696s37.888-10.24 54.272 18.944c16.384 29.184 108.032 155.136 119.296 175.104 13.312 23.04 5.12 42.496-6.656 52.736-14.336 12.288-95.232 80.384-122.368 102.912-5.12 4.608-8.192 12.288-6.656 19.456z" p-id="3304" fill="#f75959"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div style="width: 49%;display: inline-block;vertical-align: top;" :key="index">
                                        <div class="tte-name"><h4><span>{{item.Name}}：</span></h4></div>
                                        <div class="con-body-text">
                                            <div class="inf-con"><span>{{item.Value}}</span></div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else-if="item.Name == '现场资料'">
                                <div :key="index">
                                    <div class="tte-name"><h4><span>{{item.Name}}：</span></h4></div>
                                    <div class="con-body-text" v-if="item.Value.length != 0">
                                        <template v-for="(items,i) in item.Value" >
                                            <div class="word-ex" :key="i" :data-id="items.Id">
                                                <template v-if="items.FileUrl.indexOf('.jpg') !== -1 || items.FileUrl.indexOf('.png') !== -1 || items.FileUrl.indexOf('.jpeg') !== -1 || items.FileUrl.indexOf('.gif') !== -1">
                                                    <span> 
                                                        <img :src="items.IconUrl" preview="1" :preview-text="items.FileName" :alt="items.FileName" />
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <a :href="items.FileUrl">
                                                        <img :src="items.IconUrl" :alt="items.FileName" />
                                                    </a>
                                                </template>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="con-body-text" v-else>
                                        <div class="inf-con"><span>无</span></div>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="item.Name == '特殊说明'">
                                <div class="special-ins" :key="index">
                                    <div class="tte-name"><h4><span>{{item.Name}}：</span></h4></div>
                                    <div class="table-wrap" v-if="item.Value.length != 0">
                                        <template v-for="(items,i) in item.Value" >
                                            <div class="item-content" :key="i" :data-id="items.Id" :data-select="items.SelectStatus">
                                                <h2>{{items.Name}}</h2>
                                                <p>{{items.Remark}}</p>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="con-body-text" v-else style="padding-left: 0;">
                                        <div class="inf-con"><span>无</span></div>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div :key="index">
                                    <div class="tte-name"><h4><span>{{item.Name}}：</span></h4></div>
                                    <div class="con-body-text">
                                        <div class="inf-con"><span>{{item.Value}}</span></div>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <template v-if="OrderCostInfo != null && OrderPlatForm == 5 && !IsProjectOrder">
                        <div class="money-detailed" style="">
                            <div class="title-overflow">
                                <div class="top-title-operate">
                                    <h2>预收入明细</h2>
                                    <span class="detailed-num">预估收入：<i>￥{{parseFloat(OrderCostInfo.LastPrice).toFixed(2)}}</i></span>
                                </div>
                            </div>
                            <div class="table-money">
                                <table>
                                    <thead>
                                        <tr>
                                            <th><span>日期</span></th>
                                            <th><span>时间属性</span></th>
                                            <th><span>工程师数量</span></th>
                                            <th><span>服务价格（元/天）</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,i) in OrderCostInfo.ItemDayAmount" :key="i">
                                            <td><span>{{item.DateStr}}</span></td>
                                            <td><span>{{item.DateType}}</span></td>
                                            <td><span>{{item.EngineerCount}}</span></td>
                                            <td><span>￥{{parseFloat(item.DayAmount).toFixed(2)}}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>
                </div>
            </transition>
        </div>
        <!-- <div class="yes-wrap-acc">
            <div class="bg-hei"></div>
            <div class="acc-ku-wrap">
                <div class="con-acc">
                    <h2>您呼叫的电话号码为：</h2>
                    <p style="font-weight: 600;font-size: 18px;">122120102023949</p>
                    <div class="submit-engineer">
                        <button @click="bindPhone()">确定</button>
                    </div>
                </div>
            </div>
        </div> -->
        </div>
</template>
<script>
import { 
    AXBindPhone             //获取虚拟号码
} from "@/scripts/api.js";
import { bpoAlert } from '@/scripts/bpo.js'
export default {
    props: {
        OrderTitle      : String,       //工单标题
        OrderAddress    : String,       //工单地址
        OrderBaseInfo   : Array,        //地址下边基本信息
        OrderDetailList : Array,        //工单详细信息里列表表格
        isToggle        : Boolean,      //表格 产品数量数列 是否显示
        OrderDetailInfo : Array,        //工单详情从下标 1 开始循环遍历
        OrderCostInfo   : null,         //预收入费用明细 未承接为null 不显示
        toggleBoxBtn    : Boolean,      //是否显示 收起/展开
        OrderStep       : null,
        OrderPlatForm   : null,         //工单类型 自由平台=1；大客户=2；西门子=3；品牌企业=4；BTB平台=5
        IsProjectOrder  : Boolean,      //是否是项目单子，true项目单子，false标准单子
        PickOrderSence  : null,         //1 服务站接单（服务报告由服务站提交）；2 虚拟服务站接单（服务报告由速派工程师提交）；3 工程师直接承接自由平台单子（服务报告由工程师提交）; 4 自己发自己接
    },
    data(){
        return {
            boxShow     : this.toggleBoxBtn,
        }  
    },
    created(){
        this.$nextTick(()=>{
            this.$previewRefresh();  //图片必须预览刷新才可以点击放大
        })
    },
    watch: {
        toggleBoxBtn(){
            this.boxShow = this.toggleBoxBtn
        }
    },
    methods:{
        toggleBox(){
            this.boxShow = !this.boxShow;
            this.$previewRefresh(); //图片必须预览刷新才可以点击放大 
        },
        //拨打手机号
        bindPhone(phone){
            // console.log(phone)
            this.$emit("callIsShow",phone)

            // var data = {
            //     orgNumber: phone,
            //     platform: 'pcweb'
            // }
            // AXBindPhone(data).then(res=>{
            //     if(res.Result != 1){
			// 		this.$toast(res.Message)
			// 		return;
			// 	}
            //     console.log(res)
            //     bpoAlert('您呼叫的电话号码为：'+ res.Data.PrivateNumber)
            // })
        },
    },
}
</script>
<style>
.info-box {
    padding-bottom: 30px;
}
.look-info {
    position: relative;
    border-bottom: 1px solid #e5e5e5;
}
.look-info .int-i {
    display: inline-block;
    vertical-align: top;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    color: #999;
    font-size: 14px;
    transition: all 120ms ease-in-out;
    -webkit-transition: all 120ms ease-in-out;
    -moz-transition: all 120ms ease-in-out;
    -o-transition: all 120ms ease-in-out;
}
.look-info {
    padding-top: 26px;
    padding-bottom: 26px;
}
.look-info .int-i:hover {
    color: #f75959;
}
.look-info h2 {
    font-size: 30px;
    color: #333;
    margin: 20px 0;
    line-height: 36px;
    font-weight: 700;
}
.look-info .address-text {
    line-height: 34px;
    font-size: 14px;
    padding-left: 24px;
    color: #666;
    background-image: url(../../../assets/address-icon.png);
    background-repeat: no-repeat;
    background-position: left center;
    padding-bottom: 0;
}
.look-info .info-state {
    margin-bottom: 0;
}
.look-info .info-state li {
    float: left;
    width: 50%;
    font-size: 14px;
    color: #666;
    line-height: 18px;
    padding-right: 10px;
}
.look-info .info-state li p {
    position: relative;
    padding-left: 96px;
    margin-bottom: 0;
    line-height: 34px;
}
.look-info .info-state li span {
    color: #999;
    position: absolute;
    left: 0;
    top: 0;
}
.list-info-c1 {
    overflow: hidden;
}
.detail-table-info {
    padding-top: 32px;
    margin-bottom: 20px;
}
.detail-table-info table {
    width: 100%;
    border: 1px solid #e5e5e5;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
}
.detail-table-info table th,
.detail-table-info table td {
    border-bottom: 1px solid #e5e5e5;
    height: 46px;
    text-align: center;
    font-size: 12px;
    padding: 0 6px;
}
.detail-table-info table th {
    color: #999;
    background: #f9f9f9;
    font-weight: normal;
}
.detail-table-info table td {
    color: #666;
}
.detail-table-info table td span {
    display: inline-block;
    vertical-align: middle;
    line-height: 20px;
    font-family: 'DIN-Regular';
}
.info-wrap-box {
    padding-bottom: 30px;
}
.info-wrap-box > div {
    position: relative;
    margin-bottom: 18px;
}
.info-wrap-box > div:last-child {
    margin-bottom: 0;
}
.tte-name {
    position: absolute;
    left: 0;
    top: 0;
    color: #999;
}
.tte-name h4 {
    line-height: 24px;
    font-size: 14px;
    margin: 0;
    font-weight: normal;
}
.con-body-text {
    padding-left: 126px;
    font-size: 14px;
    line-height: 24px;
    overflow: hidden;
}
.con-body-text .inf-con > * {
    display: inline-block;
    vertical-align: top;
    color: #666;
    margin-right: 20px;
}
.col-f7 {
    color: #f75959 !important;
}
.word-ex {
    display: inline-block;
    vertical-align: top;
    width: 80px;
    height: 80px;
    margin-right: 20px;
    margin-bottom: 20px;
    border: 1px solid #e5e5e5;
}
.word-ex span {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    
    transition: all .2s ease-in-out;
    -webkit-transition: all .2s ease-in-out;
    -moz-transition: all .2s ease-in-out;
    -o-transition: all .2s ease-in-out;
}
.word-ex a {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.word-ex a img,
.word-ex span img {
    display: block;
    height: auto;
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-width: 100%;
}
.time-b1 {
    margin-bottom: 50px;
}

.title-overflow {
    overflow: hidden;
}
.top-title-operate {
    margin-bottom: 10px;
}
.top-title-operate h2 {
    font-size: 24px;
    line-height: 56px;
    color: #333;
    font-weight: 600;
    display: inline-block;
    vertical-align: top;
    padding-right: 24px;
}
.top-title-operate .detailed-num {
    color: #999;
    font-size: 14px;
    display: inline-block;
    vertical-align: bottom;
    padding-bottom: 10px;
}
.top-title-operate .detailed-num i {
    color: #ff3838;
    font-size: 22px;
    font-weight: 600;
}
.top-title-operate em.tis {
    display: inline-block;
    vertical-align: top;
    color: #ff3838;
    font-size: 16px;
    line-height: 56px;
    font-weight: 600;
    margin-left: -20px;
}
.top-title-operate .click-look-chage {
    float: right;
    border: none;
    background: none;
    color: #ff3838;
    font-size: 16px;
    line-height: 20px;
    margin-top: 20px;
}
.top-title-operate .click-look-chage:hover {
    text-decoration: underline;
}
.table-money table {
    width: 100%;
    border-spacing: 0;
    table-layout: fixed;
    border-collapse: collapse;
}
.table-money table th {
    line-height: 42px;
    font-size: 14px;
    font-weight: normal;
    color: #999;
    border-bottom: 1px solid #ff3838;
    text-align: center;
}
.table-money table td {
    color: #333;
    font-size: 14px;
    padding: 22px 8px 0px 0px;
    text-align: center;
}
.click-wrap {
	display: inline-block;
	position: absolute;
	right: 0;
	bottom: 0;
	text-align: center;
}
.info-det-wrap .look-info .int-i {
	display: inline-block;
	vertical-align: top;
	line-height: 28px;
	text-align: center;
	cursor: pointer;
	color: #999;
	font-size: 14px;
	transition: all 120ms ease-in-out;
	-webkit-transition: all 120ms ease-in-out;
	-moz-transition: all 120ms ease-in-out;
	-o-transition: all 120ms ease-in-out;
}
.info-det-wrap .look-info {
	padding-top: 26px;
	padding-bottom: 26px;
}
.info-det-wrap .look-info .int-i:hover {
	color: #f75959;
}
.router-slid-enter-active, .router-slid-leave-active {
  transition: all .4s;
}
.router-slid-enter, .router-slid-leave-active {
  transform: translate3d(0, 3rem, 0);
  opacity: 0;
}

/* 迭代1  */
.special-ins {
    padding-top: 40px;
}
.table-wrap {
    border: 1px solid rgba(226,226,226,1);
    display: flex;
    flex-wrap: wrap;
}
.table-wrap .item-content {
    flex: 0 0 50%;
    border-bottom: 1px solid rgba(226,226,226,1);
    border-right: 1px solid rgba(226,226,226,1);
    padding: 10px 10px;
}
.table-wrap .item-content:nth-child(odd) {
    border-top: 1px solid rgba(226,226,226,1);
    border-bottom: none;
}
.table-wrap .item-content:nth-child(even) {
    border-top: 1px solid transparent;
    border-right: none;
}
.table-wrap .item-content:first-child {
    border-top: none;
}
.table-wrap .item-content:last-child {
    border-bottom: none;
}
.table-wrap .item-content h2 {
    font-size: 14px;
    font-weight: 500;
    color: rgba(51,51,51,1);
    line-height: 20px;
    padding-bottom: 6px;
}
.table-wrap .item-content p {
    font-size:14px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height: 20px;
}
/* 迭代 */
.phone-strong {
    display: flex;
    align-items: center;
}
.phone-strong span,
.phone-strong i {
    color: #f75959 !important;
    position: relative !important;
    margin-right: 12px !important;
    cursor: pointer;
}
.phone-strong span::after,
.phone-strong i::after {
    content: '';
    width: 100%;
    height: 2px;
    background: #f75959;
    position: absolute;
    bottom: 4px;
    left: 0;
}
.phone-strong span::after {
    bottom: -2px;
}
</style>